// InterviewScreening.jsx
import React from 'react';
import styles from './InterviewScreening.module.css';
import calendarIllustration from '../../Images/CalendarDots.png'; // Your PNG path
import keyfeatures from '../../Images/sec03.png';
import howItsWork from '../../Images/sec04.png';
import handshakePhoto from '../../Images/Frame 1000006590.png'
import icon1 from '../../Images/icon1.png'
import icon2 from '../../Images/icon2.png'
import icon3 from '../../Images/icon2.png'
import icon4 from '../../Images/icons4.png'
import notificationIcon1 from '../../Images/notificationIcon1.png'
import notificationIcon2 from '../../Images/notificationIcon2.png'
import notificationIcon3 from '../../Images/notificationIcon3.png'
import AiIcon1 from '../../Images/AiIcon1.png'
import AiIcon2 from '../../Images/AiIcon2.png'
import AiIcon3 from '../../Images/AiIcon3.png'
import Ic1 from '../../Images/Ic1.png'
import img1 from '../../Images/img1.png'
import img2 from '../../Images/img2.png'
import img3 from '../../Images/img3.png'
import img4 from '../../Images/img4.png'
import FF1 from '../../Images/FF1.png'
import wave from '../../Images/keyfeatures-wave.png'
import hw1 from '../../Images/how-it-works-lines.png'






import { Clock, Zap, Globe, Users, Calendar, Bell } from 'lucide-react';

const InterviewScreening = () => {
  return (
    <div className={styles.container}>

      {/* HERO -  */}
      <section className={styles.hero}>
        <h1>
          Automate Your Interview Scheduling<br />
          with <span className={styles.gradientText}>AI</span>
        </h1>
        <p>
          Toxbox AI coordinates, schedules, and manages interviews automatically — reducing
          manual work and improving candidate experience.
        </p>

        <div className={styles.heroButtons}>
          <button className={styles.btnPrimary}>Get Started Free</button>
          <button className={styles.btnOutline}>Request a Demo</button>
        </div>

        <div className={styles.calendarIllustration}>
          <img
            src={calendarIllustration}
            alt="Toxbox AI Scheduling"
            className={styles.heroImage}
          />
        </div>
      </section>

      {/* WHY AI INTERVIEW SCHEDULING -*/}
      <section className={styles.whySection}>
        <h2 className={styles.sectionTitle}>Why AI Interview Scheduling?</h2>

        <div className={styles.whyGrid}>
          {/* Card 1: Save Time */}
          <div className={styles.whyCard}>
            <div className={styles.iconContainer}>
              <Clock className={styles.icon} />
            </div>
            <h3 className={styles.cardTitle}>Save Time</h3>
            <p className={styles.cardSubtitle}>No more back-and-forth emails or calls.</p>
            {/* <p className={styles.cardDesc}>AI finds the perfect time slot automatically</p> */}
          </div>

          {/* Card 2: Reduce No-Shows */}
          <div className={styles.whyCard}>
            <div className={styles.iconContainer}>
              <Zap className={styles.icon} />
            </div>
            <h3 className={styles.cardTitle}>Reduce No-Shows</h3>
            <p className={styles.cardSubtitle}>Automated reminders and confirmations for candidates.</p>
            {/* <p className={styles.cardDesc}>Smart AI handles all communication</p> */}
          </div>

          {/* Card 3: Integrate Seamlessly */}
          <div className={styles.whyCard}>
            <div className={styles.iconContainer}>
              <Globe className={styles.icon} />
            </div>
            <h3 className={styles.cardTitle}>Integrate Seamlessly</h3>
            <p className={styles.cardSubtitle}>Works with your ATS and calendar apps.</p>
            {/* <p className={styles.cardDesc}>Google, Outlook, Zoom & Teams</p> */}
          </div>

          {/* Card 4: Improve Candidate Experience */}
          <div className={styles.whyCard}>
            <div className={styles.iconContainer}>
              <Users className={styles.icon} />
            </div>
            <h3 className={styles.cardTitle}>Improve Candidate Experience</h3>
            <p className={styles.cardSubtitle}>Quick, smooth, and professional scheduling.</p>
            {/* <p className={styles.cardDesc}>Modern, fast, and professional experience</p> */}
          </div>
        </div>
      </section>


          {/* KEY FEATURES */}
      <section className={styles.keyFeaturesSection}>
        {/* Wave Background Image */}
        <img 
          src={wave}
          alt="" 
          className={styles.waveImage} 
        />

        <div className={styles.featuresContent}>
          <h2 className={styles.keyFeaturesTitle}>Key Features</h2>

          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Calendar />
              </div>
              <h3>Smart Scheduling</h3>
              <p>AI suggests optimal interview times based on availability.</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Globe />
              </div>
              <h3>Calendar Integration</h3>
              <p>Sync with Google Calendar, Outlook, or internal systems.</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Bell />
              </div>
              <h3>Automated Reminders</h3>
              <p>Email/SMS reminders for candidates and interviewers.</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Clock />
              </div>
              <h3>Rescheduling Made Easy</h3>
              <p>AI handles reschedule requests automatically.</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Users />
              </div>
              <h3>Time Zone Management</h3>
              <p>Schedule interviews across global teams effortlessly.</p>
            </div>
          </div>
        </div>
      </section>


               {/* HOW IT WORKS – 100% EXACT TO YOUR FIGMA + SCREENSHOT */}
      <section className={styles.howItWorksSection}>
        <h2 className={styles.howTitle}>How it works</h2>

        <div className={styles.howContainer}>
          {/* Step 1 */}
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>1</div>
            <p>Candidate applies for a role</p>
          </div>

          {/* Step 2 */}
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>2</div>
            <p>AI checks interviewer availability<br />and suggests slots</p>
          </div>

          {/* Step 3 */}
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>3</div>
            <p>Candidate confirms a preferred time</p>
          </div>

          {/* Step 4 */}
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>4</div>
            <p>AI sends reminders and updates<br />calendars</p>
          </div>

          {/* Step 5 */}
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>5</div>
            <p>Interview is conducted on time,<br />every time</p>
          </div>

          {/* DOTTED CURVED LINES – YOUR EXACT PNG */}
          <img 
            src={hw1}
            alt="" 
            className={styles.dottedLines} 
          />
        </div>
      </section>


      {/* BENEFITS SECTION */}
      <section className={styles.benefitsSection}>
        <h2 className={styles.benefitsTitle}>Benefits</h2>

        <div className={styles.benefitsGrid}>
          {/* LEFT SIDE – IMAGE (empty now, add later) */}
          <div className={styles.benefitsImageBox}>
            {/* ←←← ADD YOUR HANDSHAKE PHOTO HERE LATER */}
            <img src={handshakePhoto} alt="Recruiter handshake" />
          </div>

          {/* RIGHT SIDE – 4 CARDS IN 2x2 GRID */}
          <div className={styles.cardsGrid}>
            {/* Card 1 */}
            <div className={styles.benefitCard}>
              <div className={styles.iconPlaceholder}>
                {/* Replace this with your own PNG later */}
                <img src={icon1} alt="Efficient Recruitment" />
              </div>
              <h3>Efficient Recruitment</h3>
              <p>Save hours in manual scheduling.</p>
            </div>

            {/* Card 2 */}
            <div className={styles.benefitCard}>
              <div className={styles.iconPlaceholder}>
                <img src={icon2} alt="Reduce Candidate Drop-off" />
              </div>
              <h3>Reduce Candidate Drop-off</h3>
              <p>Fast, responsive scheduling keeps candidates engaged.</p>
            </div>

            {/* Card 3 */}
            <div className={styles.benefitCard}>
              <div className={styles.iconPlaceholder}>
                <img src={icon3} alt="Global Collaboration" />
              </div>
              <h3>Global Collaboration</h3>
              <p>Manage interviews across different time zones.</p>
            </div>

            {/* Card 4 */}
            <div className={styles.benefitCard}>
              <div className={styles.iconPlaceholder}>
                <img src={icon4} alt="Error-Free Coordination" />
              </div>
              <h3>Error-Free Coordination</h3>
              <p>No double bookings or missed interviews.</p>
            </div>
          </div>
        </div>
      </section>


      {/*  MULTICHANNEL NOTIFICATIONS SECTION */}
      <section className={styles.notificationsSection}>

        <h2 className={styles.notificationsTitle}>Multichannel Notifications</h2>

        <div className={styles.notificationsGrid}>

          {/* ==================================
         CARD 1 — Email Notifications
       ================================== */}
          <div className={styles.notifyCard}>
            <div className={styles.iconBox}>
              <img src={notificationIcon1} alt="Email Notifications" />
            </div>
            <h3>Email Notifications</h3>
            <p>Interview confirmations and reminders.</p>
          </div>

          {/* ==================================
         CARD 2 — SMS Alerts
       ================================== */}
          <div className={styles.notifyCard}>
            <div className={styles.iconBox}>
              <img src={notificationIcon2} alt="SMS Alerts" />
            </div>
            <h3>SMS Alerts</h3>
            <p>Quick updates for candidates on the go.</p>
          </div>

          {/* ==================================
         CARD 3 — In-App Notifications
       ================================== */}
          <div className={styles.notifyCard}>
            <div className={styles.iconBox}>
              <img src={notificationIcon3} alt="In-App Notifications" />
            </div>
            <h3>In-App Notifications</h3>
            <p>For recruiters using Toxbox AI platform.</p>
          </div>

        </div>
      </section>

      {/* AI */}
      <section className={styles.aiRecommendSection}>
        <div className={styles.aiRecommendContainer}>

          <h2 className={styles.aiRecommendTitle}>AI-Powered Recommendations</h2>

          <div className={styles.aiRecommendContent}>

            {/* ROW 1 */}
            <div className={styles.aiRow}>
              <img src={AiIcon1} alt="Recommends Interviewers" className={styles.aiImage} />
              <p className={styles.aiText}>Suggests optimal interviewers for each candidate.</p>
            </div>

            {/* ROW 2 */}
            <div className={styles.aiRow}>
              <p className={styles.aiText}>Prioritizes interview times based on urgency and availability.</p>
              <img src={AiIcon2} alt="Prioritizes" className={styles.aiImage} />
            </div>

            {/* ROW 3 */}
            <div className={styles.aiRow}>
              <img src={AiIcon3} alt="Detect Conflicts" className={styles.aiImage} />
              <p className={styles.aiText}>Detects potential scheduling conflicts in advance.</p>
            </div>

          </div>
        </div>
      </section>
      
      {/* rescheduleSection */}
      <section className={styles.rescheduleSection}>
        <div className={styles.rescheduleContainer}>

          <h2 className={styles.rescheduleTitle}>Rescheduling & Flexibility</h2>

          <div className={styles.cardRow}>

            <div className={styles.card}>
              <div className={styles.iconBox}>
                <img src={Ic1} alt="request slots" />
              </div>
              <p className={styles.cardText}>Candidates can request new slots.</p>
            </div>

            <div className={styles.card}>
              <div className={styles.iconBox}>
                <img src={Ic1} alt="recalibrate" />
              </div>
              <p className={styles.cardText}>
                AI automatically recalibrates schedules and sends updates.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.iconBox}>
                <img src={Ic1} alt="avoid intervention" />
              </div>
              <p className={styles.cardText}>
                Avoids recruiter intervention for common changes.
              </p>
            </div>

          </div>
        </div>
      </section>


         {/* INDUSTRY APPLICATIONS */}
      <section className={styles.industrySection}>
        <h2 className={styles.industryTitle}>Industry Applications</h2>

        <div className={styles.industryGrid}>
          {/* Card 1 */}
          <div className={styles.industryCard}>
            <div className={styles.industryText}>
              <h3>Tech & IT</h3>
              <p>Schedule coding interviews efficiently.</p>
            </div>
            <div className={styles.industryImage}>
              <img src={img3} alt="Tech & IT" />
            </div>
          </div>

          {/* Card 2 */}
          <div className={styles.industryCard}>
            <div className={styles.industryText}>
              <h3>Corporate & Finance</h3>
              <p>Manage multiple rounds with ease.</p>
            </div>
            <div className={styles.industryImage}>
              <img src={img4} alt="Corporate & Finance" />
            </div>
          </div>

          {/* Card 3 */}
          <div className={styles.industryCard}>
            <div className={styles.industryText}>
              <h3>Healthcare & Pharma</h3>
              <p>Candidates can request new slots.</p>
            </div>
            <div className={styles.industryImage}>
              <img src={img1} alt="Healthcare" />
            </div>
          </div>

          {/* Card 4 */}
          <div className={styles.industryCard}>
            <div className={styles.industryText}>
              <h3>Education & Training</h3>
              <p>Schedule teaching assessments and interviews.</p>
            </div>
            <div className={styles.industryImage}>
              <img src={img2} alt="Education" />
            </div>
          </div>
        </div>
      </section>


           {/* TESTIMONIALS */}
      <section className={styles.testimonialsSection}>
        <h2 className={styles.testimonialsTitle}>
          Recruiters Love Toxbox AI Scheduling
        </h2>

        <div className={styles.testimonialsWrapper}>
          {/* Card 1 */}
          <div className={styles.testimonialCard}>
            <div className={styles.quoteIcon}>“</div>
            <p className={styles.testimonialText}>
              AI scheduling eliminated hours of email back-and-forth with candidates. Now interviews are booked in minutes.
            </p>
            <div className={styles.testimonialFooter}>
              <img src="/avatars/sara.jpg" alt="Sara David" className={styles.avatar} />
              <div>
                <div className={styles.name}>Sara David</div>
                <div className={styles.role}>HR Manager, Tech Firm</div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className={styles.testimonialCard}>
            <div className={styles.quoteIcon}>“</div>
            <p className={styles.testimonialText}>
              Our candidates appreciate timely reminders and smooth scheduling experience. It reflects positively on our employer brand.
            </p>
            <div className={styles.testimonialFooter}>
              <img src="/avatars/savannah.jpg" alt="Savannah Nguyen" className={styles.avatar} />
              <div>
                <div className={styles.name}>Savannah Nguyen</div>
                <div className={styles.role}>Corporate Recruiter</div>
              </div>
            </div>
          </div>
        </div>
      </section>

            {/* FINAL CTA SECTION */}
      <section className={styles.ctaSection}>
        <div className={styles.ctaOverlay}></div>

        <div className={styles.ctaContent}>
          <h2 className={styles.ctaTitle}>
            Schedule Interviews Smarter with AI
          </h2>
          <p className={styles.ctaSubtitle}>
            Automate scheduling, reduce errors, and ensure timely interviews with Toxbox AI.
          </p>

          <div className={styles.ctaButtons}>
            <button className={styles.ctaBtnPrimary}>Get Started</button>
            <button className={styles.ctaBtnSecondary}>Request a Demo</button>
          </div>
        </div>
      </section>

           {/* SECURE & RELIABLE*/}
      <section className={styles.secureSection}>
        <h2 className={styles.secureTitle}>
          Secure & Reliable Interview Scheduling
        </h2>

        <div className={styles.secureWrapper}>
          {/* LEFT – BULLET POINTS */}
          <ul className={styles.secureList}>
            <li>GDPR-compliant candidate data handling</li>
            <li>Secure calendar and notification management</li>
            <li>Trusted by enterprises worldwide</li>
          </ul>

          {/* RIGHT – ILLUSTRATION WITH PURPLE BLOB */}
          <div className={styles.secureIllustBox}>
            <div className={styles.purpleBlob}></div>
            <div className={styles.secureCard}>
              {/* ←←← ADD YOUR PNG ILLUSTRATION HERE LATER */}
              <img src={FF1} alt="Secure scheduling" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InterviewScreening;